const faqs = document.querySelectorAll(".faq");
for (const item of faqs) {
  const curr_faq = item.childNodes;
  const question = curr_faq[1];
  const answer = curr_faq[3];
  const icon = question.querySelector(".icon-main");
  icon.addEventListener("click", function () {
    answer.classList.toggle("active");
    const i = icon.querySelector("i");
    i.classList.toggle("fa-minus");
    i.classList.toggle("fa-plus");  
  });
}
